class CollectionPage {
  constructor() {
    this.scrollToProductCard();
  }
  scrollToProductCard() {

    const pageUrlParams = new URLSearchParams(window.location.search);
    const pid = pageUrlParams.get('pid');
    // check if #pid= is in the URL
    if (!window.location.href.includes('pid=')) return

    // get the product id from the URL
    const productId = window.location.href.split('pid=')[1]
    const productCard = document.querySelector(`product-card[data-product-id="${productId}"]`)

    if (!productCard) return

    // scroll to the product card
    setTimeout(() => {

      const headerEl = document.querySelector("header.site-header")
      if (headerEl) {
        const yOffset = headerEl.getBoundingClientRect().height * -1
        const y = (productCard.getBoundingClientRect().top + window.pageYOffset) + yOffset

        window.scrollTo({top: y, behavior: 'instant'})
      }

      // turn on smooth scrolling
      //document.documentElement.classList.remove('noSmoothScroll')
    }, 0)
  }
}

const collectionPage = new CollectionPage();

document.addEventListener('onload', collectionPage);
